import React from 'react'
import PropTypes from 'prop-types'
import FormattedReviewsData from './FormattedReviewsData'
import css from './reviews-box.css'

const ReviewsBox = ({
  totalCount,
  last30Days,
  byDoctor,
  byLocation,
}) => {
  const last30DaysPositivePercent = ((last30Days.positive / (last30Days.total || 1)) * 100).toFixed()
  return (
    <div className={css.container}>
      <div className={css.headsUp}>
        <p>Total Reviews</p>
        <p>{totalCount}</p>
      </div>
      <div className={css.table}>
        <div className={css.row}>
          <span className={css.cell}>Reviews Submitted (last 30 days)</span>
          <span className={css.cell}>{last30Days.total}</span>
        </div>
        <div className={css.row}>
          <span className={css.cell}>Positive Reviews (last 30 days)</span>
          <span className={css.cell}>{last30DaysPositivePercent}%</span>
        </div>
        <FormattedReviewsData
          type="doctor"
          data={byDoctor}
        />
        <FormattedReviewsData
          type="location"
          data={byLocation}
        />
      </div>
    </div>
  )
}

ReviewsBox.propTypes = {
  totalCount: PropTypes.number.isRequired,
  last30Days: PropTypes.shape({
    total: PropTypes.number.isRequired,
    negative: PropTypes.number.isRequired,
    positive: PropTypes.number.isRequired,
  }),
  byDoctor: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    reviews: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      positive: PropTypes.bool,
      stars: PropTypes.number,
    })),
  })),
  byLocation: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    reviews: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      positive: PropTypes.bool,
      stars: PropTypes.number,
    })),
  })),
}

export default ReviewsBox



// WEBPACK FOOTER //
// ./src/components/Dashboard/ReviewsBox.js